import React, { Component } from 'react'
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Container, FlexSpaceWrapper, FlexSpaceWrapperCenter, Gutter, WhiteBtn, MenuTitle, SearchLayout, TextInput, BlackBtnInput, PageTitle } from '../stylesheets/components';
import Routes from '../constants/routes';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { SearchPersonMapContainer } from '../components';
import { numberWithDelimiter, tablize } from '../utils';
import _ from 'lodash';
import qs from 'qs';

const Fragment = React.Fragment;
const Hero = styled.div`
  background-color: white;
`;

const FlexSpaceBaseline = styled(FlexSpaceWrapper)`
  align-items: flex-end;
`;

const LabLogo = styled.a`
  position: absolute;
  right: 0;
  top: 40px;
`;

const HeroContainer = styled(Container)`
  padding: 40px 0 50px 0;
  position: relative;
`;  

const Column = styled.div`
  p {
    font-family: "Playfair Display";
    font-size: 1.2em;
    line-height: 1.4;
    color: white;
  }

  width: calc(50% - 20px);
`;

const WikipediaDesc = styled.div`
  font-family: "Playfair Display";
  font-size: 1.2em;
  line-height: 1.4;
  padding: 10px 0 0 0;
`; 

const Disclaimer = styled.div`
  font-family: "Brandon Text";
  font-size: 0.9em;
  font-style: italic;
  color: #888;
  line-height: 1.2;
`;

class SearchCities extends Component {
  constructor(props){
    super(props);
    this.state = {
      page: 1,
      cs_results_count: 0,
      query: "",
      county_subdivisions: []
    }
  }
  componentDidMount(){
    this.loadData();
  }

  handleSearchValue(e){
    this.setState({
      query: e.value
    });
  }


  async loadData(){

    const headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }

    let params = qs.parse(this.props.location.search.replace("?", ""));
    
    const response = await fetch(`/api/search-cities${this.props.location.search}`, { method: "get", headers });
    if (response.ok) {
      let data = await response.json();
      this.setState({
        page: data.page,
        query: params.query,
        cs_results_count: data.cs_results_count,
        county_subdivisions: data.county_subdivisions
      });
      // this.props.dispatch(changeMatchedPeople(data.fullname_search_people, data.lastname_search_people));

    } else {
      // let data = await response.json();
      console.log(response);
    }
  }

  render() {
    let { windowWidth } = this.props;
    let { 
      query,
      county_subdivisions,
      cs_results_count,
      page
    } = this.state;
    return (
      <Fragment>
        <Container>
          <Gutter h={50} />
          <FlexSpaceWrapper>


            <Column>
              <MenuTitle>
                Search Result for { query }
              </MenuTitle>
              <Gutter h={25} />
              <form action={Routes.search_cities_path()} acceptCharset="UTF-8" method="get">
                <SearchLayout>
                  <TextInput onChange={this.handleSearchValue.bind(this) } className="search" type="text" name="query" id="query" value={query} placeholder="e.g., Concord, Somerville..." />
                  <BlackBtnInput className="search" type="submit" name="commit" value="Search" data-disable-with="Search" />
                </SearchLayout>
              </form>
            </Column>
            
          </FlexSpaceWrapper>

          <Gutter h={40} />

          <FlexSpaceWrapper>


            <Column>

              <MenuTitle>
                { numberWithDelimiter(cs_results_count) } Cities and Towns
              </MenuTitle>
              <Gutter h={25} />

              <table>
                <thead>
                  <tr>
                    <th className="left">
                      Name
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {
                    _.map(county_subdivisions, county_subdivision => {
                      return (
                        <tr key={county_subdivision.id}>  
                          <td>
                            <Link to={Routes.county_subdivision_path(county_subdivision["id"])}>
                              { county_subdivision["namelsad"]}, {county_subdivision["state_name"]}
                            </Link>
                          </td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </table>
            </Column>

            <Column>


              </Column>

          </FlexSpaceWrapper>

          <Gutter h={50} />
        </Container> 
      </Fragment>
    )
  }
}

let mapStateToProps = state => {
  return {
    windowWidth: state.windowWidth
  }
}

export default withRouter(connect(mapStateToProps)(SearchCities));